import React, { useContext } from 'react'
import { MenuMainContext } from 'contexts/MenuMain'
import { Container } from './styles'

const HeaderPad = () => {
  const { isSalesBanner, salesBannerHeight } = useContext(MenuMainContext)
  return (
    <Container
      withExtraIndent={isSalesBanner}
      indentHeight={salesBannerHeight}
    />
  )
}

export default HeaderPad
